export function anonymizeLastName(lastName?: string | null): string {
  const ln = (lastName ?? '').trim();
  if (!ln) return '';
  if (ln.length === 1) return ln;
  // Affiche uniquement l’initiale + un point pour limiter la divulgation.
  return `${ln.charAt(0).toUpperCase()}.`;
}

export function anonymizePersonName(person?: {
  firstName?: string | null;
  lastName?: string | null;
} | null): string {
  const first = (person?.firstName ?? '').trim();
  const last = (person?.lastName ?? '').trim();

  if (!first && !last) return 'Inconnu';
  if (!first) return anonymizeLastName(last) || 'Inconnu';
  if (!last) return first;

  return `${first} ${anonymizeLastName(last)}`;
}

export function anonymizeFullName(fullName?: string | null): string {
  const cleaned = (fullName ?? '').trim().replace(/\s+/g, ' ');
  if (!cleaned) return 'Inconnu';

  const parts = cleaned.split(' ').filter(Boolean);
  if (parts.length === 1) return anonymizeLastName(parts[0]) || 'Inconnu';

  const first = parts[0];
  const last = parts[parts.length - 1];
  return `${first} ${anonymizeLastName(last)}`;
}

